/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_No_Next_GameInputs */

const th_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีนัดถัดไป`)
};

const en_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming fixture.`)
};

const ja_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の試合はまだありません。`)
};

const zh_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有安排比赛。`)
};

const es_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay próximo partido.`)
};

const pt_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo marcado.`)
};

const id_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pertandingan terjadwal.`)
};

const fr_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match à venir.`)
};

const tl_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakaiskedyul na laro.`)
};

const vi_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có trận nào được xếp.`)
};

const ko_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`편성된 경기가 없습니다.`)
};

const de_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Spiel angesetzt.`)
};

const ru_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначенных матчей нет.`)
};

const tr_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlanmış maç yok.`)
};

const it_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita in calendario.`)
};

const pl_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zaplanowano meczu.`)
};

const uk_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запланованих матчів немає.`)
};

const hi_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मैच निर्धारित नहीं है।`)
};

const ar_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مباراة مجدولة.`)
};

const ms_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perlawanan dijadualkan.`)
};

const bn_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও খেলা নির্ধারিত নেই।`)
};

const zh_tw2_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有安排比賽。`)
};

const zh_hk2_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有安排比賽。`)
};

const ur_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی میچ طے نہیں۔`)
};

const fa_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌ای برنامه‌ریزی نشده.`)
};

const sw_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo uliopangwa.`)
};

const nl_home_no_next_game = /** @type {(inputs: Home_No_Next_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wedstrijd ingepland.`)
};

/**
* | output |
* | --- |
* | "No upcoming fixture." |
*
* @param {Home_No_Next_GameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_no_next_game = /** @type {((inputs?: Home_No_Next_GameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_No_Next_GameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_no_next_game(inputs)
	if (locale === "ja") return ja_home_no_next_game(inputs)
	if (locale === "zh") return zh_home_no_next_game(inputs)
	if (locale === "es") return es_home_no_next_game(inputs)
	if (locale === "pt") return pt_home_no_next_game(inputs)
	if (locale === "id") return id_home_no_next_game(inputs)
	if (locale === "fr") return fr_home_no_next_game(inputs)
	if (locale === "tl") return tl_home_no_next_game(inputs)
	if (locale === "vi") return vi_home_no_next_game(inputs)
	if (locale === "ko") return ko_home_no_next_game(inputs)
	if (locale === "de") return de_home_no_next_game(inputs)
	if (locale === "ru") return ru_home_no_next_game(inputs)
	if (locale === "tr") return tr_home_no_next_game(inputs)
	if (locale === "it") return it_home_no_next_game(inputs)
	if (locale === "pl") return pl_home_no_next_game(inputs)
	if (locale === "uk") return uk_home_no_next_game(inputs)
	if (locale === "hi") return hi_home_no_next_game(inputs)
	if (locale === "ar") return ar_home_no_next_game(inputs)
	if (locale === "ms") return ms_home_no_next_game(inputs)
	if (locale === "bn") return bn_home_no_next_game(inputs)
	if (locale === "zh-TW") return zh_tw2_home_no_next_game(inputs)
	if (locale === "zh-HK") return zh_hk2_home_no_next_game(inputs)
	if (locale === "ur") return ur_home_no_next_game(inputs)
	if (locale === "fa") return fa_home_no_next_game(inputs)
	if (locale === "sw") return sw_home_no_next_game(inputs)
	if (locale === "nl") return nl_home_no_next_game(inputs)
	return en_home_no_next_game(inputs)
});